import * as yup from 'yup'

export type CancellationReason =
  | 'wrong_billing'
  | 'service_cancellation'
  | 'issue_error'
  | 'non_payment'
  | 'other'

export const cancelConfirmationSchema = yup.object({
  cancellationReason: yup
    .string()
    .oneOf([
      'wrong_billing',
      'service_cancellation',
      'issue_error',
      'non_payment',
      'other'
    ])
    .required('Motivo do cancelamento é obrigatório'),
  countAsChurn: yup.boolean().required(),
  cancelNfses: yup.boolean().default(false),
  notes: yup.string()
})

export type CancelConfirmationFormData = yup.InferType<
  typeof cancelConfirmationSchema
>
